// extracted by mini-css-extract-plugin
export default {"wrapper":"warning__wrapper__NNcqV","icon":"warning__icon__Ae7tI","content":"warning__content__a2xbf"};